module.exports = __webpack_public_path__ + "img/pitching5.86e44b69.png";